import { render, staticRenderFns } from "./input-carnum.vue?vue&type=template&id=07af2e53&scoped=true&"
import script from "./input-carnum.vue?vue&type=script&lang=ts&"
export * from "./input-carnum.vue?vue&type=script&lang=ts&"
import style0 from "./input-carnum.vue?vue&type=style&index=0&id=07af2e53&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07af2e53",
  null
  
)

export default component.exports